"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisitTypeContent;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _VisitLabel = _interopRequireDefault(require("./VisitLabel"));
var _styles = require("./styles");
var _VisitTypes = require("../../lib/constants/VisitTypes");
var _messages = _interopRequireDefault(require("../../lib/messages"));
const VideoType = _ref => {
  let {
    type
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_VisitLabel.default, {
    Wrapper: _styles.VisitHeading,
    IconWrapper: _styles.VideoIcon,
    iconSize: "24px",
    type: type
  }), /*#__PURE__*/_react.default.createElement(_styles.VisitContent, {
    "data-testid": "VisitTypeContent"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.appointmentVideoContent)));
};
const PhoneType = _ref2 => {
  let {
    type
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_VisitLabel.default, {
    Wrapper: _styles.VisitHeading,
    IconWrapper: _styles.PhoneIcon,
    iconSize: "18px",
    type: type
  }), /*#__PURE__*/_react.default.createElement(_styles.VisitContent, {
    "data-testid": "VisitTypeContent"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.appointmentPhoneContent)));
};
function VisitTypeContent(_ref3) {
  let {
    type
  } = _ref3;
  switch (type) {
    case _VisitTypes.PHONE:
      return /*#__PURE__*/_react.default.createElement(PhoneType, {
        type: type
      });
    case _VisitTypes.VIDEO:
      return /*#__PURE__*/_react.default.createElement(VideoType, {
        type: type
      });
    default:
      return;
  }
}
const propTypes = {
  type: _propTypes.string // this always be one of them either 'video', 'phone' or 'in_person'
};
const defaultProps = {
  type: _VisitTypes.IN_PERSON
};
VisitTypeContent.propTypes = propTypes;
VisitTypeContent.defaultProps = defaultProps;
VisitTypeContent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VisitTypeContent",
  "props": {
    "type": {
      "defaultValue": {
        "value": "IN_PERSON",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};